import { Controller } from '@hotwired/stimulus';

// フォーム送信時に submit ボタンを無効化して二重送信を防ぐ
// (旧 main.js の form.single ハンドラ)。
export default class extends Controller {
  disable() {
    this.element
      .querySelectorAll('input[type=submit], button[type=submit]')
      .forEach((btn) => (btn.disabled = true));
  }
}
